export const ADMIN_ROLES = ['jbg-admin', 'pce-admin', 'arg-admin', 'customer.admin', 'client-admin', 'ipro-admin']
export const READ_ONLY_ROLE = 'jbg-read-only'

export const isReadOnlyUser = (auth) => {
  const roles = auth?.userRoles || []
  return roles.includes(READ_ONLY_ROLE) && !ADMIN_ROLES.some(role => roles.includes(role))
}

export const userAccess = {
  computed: {
    entities () {
      return ['party']
    },
    adminRoles () {
      return ADMIN_ROLES
    },
    isReadOnly () {
      return isReadOnlyUser(this.$auth)
    },
    user () {
      return this.$auth.user
    },
    tenant () {
      return this.$auth.tenant
    },
    userRoles () {
      return this.$auth.userRoles || []
    },
    userPermissions () {
      return this.$auth.permissions || []
    },
    userRelatedParties () {
      return this.$store.getters.userRelatedParties
    },
    userRelatedPartyIds () {
      if (this.userRelatedParties.length > 0) {
        return this.userRelatedParties.map(party => party.id)
      }
      return []
    },
    hasPortalAccess () {
      let hasAccess = !this.hasScope('customer:no_access') && this.hasReadAccess
      if (this.tenant === 'alliance-retail-group') {
        if (process.env.NODE_ENV === 'production' && this.noProdAccess) {
          hasAccess = false
        } else {
          hasAccess = (hasAccess && !this.restrictStoreListOnlyAccess)
        }
      }
      return hasAccess
    },
    userAccessiblePortals() {
      const portals = ['ad_planner', 'customer', 'promo', 'item', 'billing', 'tpr', 'partner']
      const isProd = process.env.NODE_ENV === 'production'

      return portals.filter(portal => {
        let readScope = `${portal}:read`
        if (portal === 'billing') {
          readScope = 'billing_batch:read'
        } else if (portal === 'customer') {
          readScope = 'party:read'
        }
        else if (portal === 'tpr') {
          readScope = 'tpr_batch:read'
        }
        else if (portal === 'partner') {
          readScope = 'document:read'
        }
        const canRead = this.hasScope(readScope)
        if (!canRead) return false

        // Hard deny in all envs
        if (this.hasScope(`${portal}:no_access`)) return false

        // Deny in prod only (dev allowed) if they have the prod-block flag
        if (isProd && this.hasScope(`${portal}:no_access_prod`)) return false

        return true
      })
    },
    noProdAccess() {
      return this.userPermissions.includes('customer:no_access_prod')
    },
    hasReadAccess () {
      const readScopes = this.entities.map(entity => `${entity}:read`)
      return readScopes.every(scope => this.userPermissions.includes(scope))
    },
    hasWriteAccess () {
      return this.writePermissions.every(scope => this.userPermissions.includes(scope))
    },
    hasStoreListAccess () {
      return (this.tenant !== 'alliance-retail-group' && this.isAdmin) || (this.tenant === 'alliance-retail-group' && (this.isAdmin || this.userPermissions.includes('customer:store_list')))
    },
    hasAdminDashboardAccess () {
      return this.tenant === 'alliance-retail-group' ? (this.isAdmin && this.isIproAdmin) : this.isAdmin
    },
    writePermissions () {
      const actions = ['create', 'read', 'update']
      return this.$auth.buildScopes(this.entities, actions)
    },
    isIproAdmin() {
      return this.userRoles.includes('iPro-Admin-Customer')
    },
    isGroupManager() {
      return this.userRoles.includes('arg-group-manager')
    },
    isStoreListOnly() {
      return this.userRoles.includes('store-list-only')
    },
    restrictStoreListOnlyAccess() {
      return this.isStoreListOnly && ((process.env.NODE_ENV === 'production') || (!this.isAdmin && !this.hasWriteAccess))
    },
    isAdmin () {
      return this.adminRoles.some(role => this.userRoles.includes(role))
    },
    limitAccessByUserParties () {
      return this.userPermissions.includes('customer:related_parties')
    }
  },
  methods: {
    hasScope (scope) {
      return this.userPermissions.includes(scope)
    }
  }
}